var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGraphBlue(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_368_4297)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 6.99041H4.6605M4.6605 6.99041C4.6605 6.37239 4.90601 5.77968 5.34301 5.34267C5.78002 4.90566 6.37273 4.66016 6.99075 4.66016C7.60877 4.66016 8.20148 4.90566 8.63849 5.34267C9.07549 5.77968 9.321 6.37239 9.321 6.99041M4.6605 6.99041C4.6605 7.60843 4.90601 8.20114 5.34301 8.63814C5.78002 9.07515 6.37273 9.32066 6.99075 9.32066C7.60877 9.32066 8.20148 9.07515 8.63849 8.63814C9.07549 8.20114 9.321 7.60843 9.321 6.99041M9.321 6.99041H13.9815",
    stroke: "#2563EB",
    strokeWidth: 1.74769
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_368_4297"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.9815,
    height: 13.9815,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphBlue);
export default __webpack_public_path__ + "static/media/graph_blue.ddc0127a24e24dddccc4d4c6706f501a.svg";
export { ForwardRef as ReactComponent };